import { css, keyframes } from 'styled-components';
import { FONT_WEIGHT } from '../../foundations/typography';
import { TagVariantType, TextVariantType } from '../variants';
const opacity = keyframes `
from {
  opacity: 0;
}
to {
  opacity: 1;
}
`;
const slideUp = keyframes `
from {
  transform: translateY(100%);
}
to {
  transform: translateY(0);
}
`;
const buttonAnimation = (FOUNDATIONS) => () => {
    return css `
    animation: ${opacity} ${FOUNDATIONS.duration_100} linear;
  `;
};
const labelAnimation = (FOUNDATIONS) => () => {
    return css `
    animation: ${slideUp} ${FOUNDATIONS.duration_150} ease-in-out;
  `;
};
export const commonStyles = (FOUNDATIONS, FONT) => ({
    focusVisible: {
        border_radius: FOUNDATIONS.radius_00,
    },
    badgeLogoContainer: {
        position: 'absolute',
        right: '-6px',
        bottom: '-6px',
    },
    quickButtonComplex: {
        position: 'relative',
        justify_content: 'center',
        align_items: 'center',
        display: 'flex',
        border_style: 'solid',
        border_width: FOUNDATIONS.border_comp_actions_quickbutton_bordersize,
        border_color: FOUNDATIONS.color_comp_actions_quickbutton_primary_default_border,
        background_color: FOUNDATIONS.color_comp_actions_quickbutton_primary_default_bg,
        border_radius: FOUNDATIONS.radius_comp_actions_quickbutton_radiussize,
        padding: FOUNDATIONS.spacing_200,
        animationsStyles: buttonAnimation(FOUNDATIONS),
    },
    container: {
        justify_content: 'center',
        align_items: 'center',
        display: 'inline-flex',
        flex_direction: 'column',
        gap: FOUNDATIONS.spacing_150,
        cursor: 'pointer',
        width: 'fit-content',
        position: 'relative',
        word_break: 'break-word',
    },
    labelContainer: {
        animationsStyles: labelAnimation(FOUNDATIONS),
        text_align: 'center',
    },
    label: {
        font_variant: TextVariantType.FONT_PARAGRAPH_350,
        font_weight: FONT_WEIGHT.font_regular,
        color: FOUNDATIONS.color_comp_actions_quickbutton_primary_default_label,
        text_align: 'center',
    },
    initials: {
        font_variant: TextVariantType.FONT_PARAGRAPH_50,
        font_weight: FONT_WEIGHT.font_regular,
        color: FOUNDATIONS.color_comp_actions_quickbutton_primary_default_initials,
    },
    icon: {
        height: FOUNDATIONS.size_350,
        width: FOUNDATIONS.size_350,
    },
    image: {
        height: FOUNDATIONS.size_500,
        width: FOUNDATIONS.size_500,
    },
    tagContainer: {
        position: 'absolute',
        top: '-0.813rem',
    },
    tag: {
        variant: TagVariantType.NEWNESS,
    },
});
export const disabledCommonStyles = (FOUNDATIONS, FONT) => ({
    ...commonStyles(FOUNDATIONS, FONT),
    container: {
        ...commonStyles(FOUNDATIONS, FONT).container,
        cursor: 'default',
    },
    quickButtonComplex: {
        ...commonStyles(FOUNDATIONS, FONT).quickButtonComplex,
        border_width: FOUNDATIONS.border_00,
        background_color: FOUNDATIONS.color_accent_disabled_bg_100,
    },
    label: {
        ...commonStyles(FOUNDATIONS, FONT).label,
        color: FOUNDATIONS.color_accent_disabled_font_100,
    },
    icon: {
        ...commonStyles(FOUNDATIONS, FONT).icon,
        color: FOUNDATIONS.color_accent_disabled_icon_100,
    },
    tag: {
        ...commonStyles(FOUNDATIONS, FONT).tag,
        variant: TagVariantType.DISABLED,
    },
});
export const secondaryCommonStyles = (FOUNDATIONS, FONT) => ({
    ...commonStyles(FOUNDATIONS, FONT),
    quickButtonComplex: {
        ...commonStyles(FOUNDATIONS, FONT).quickButtonComplex,
        border_color: FOUNDATIONS.color_comp_actions_quickbutton_secondary_default_border,
        background_color: FOUNDATIONS.color_comp_actions_quickbutton_secondary_default_bg,
    },
    label: {
        ...commonStyles(FOUNDATIONS, FONT).label,
        color: FOUNDATIONS.color_comp_actions_quickbutton_secondary_default_label,
    },
});
export const tertiaryCommonStyles = (FOUNDATIONS, FONT) => ({
    ...commonStyles(FOUNDATIONS, FONT),
    quickButtonComplex: {
        ...commonStyles(FOUNDATIONS, FONT).quickButtonComplex,
        border_color: FOUNDATIONS.color_comp_actions_quickbutton_tertiary_default_border,
        background_color: FOUNDATIONS.color_comp_actions_quickbutton_tertiary_default_bg,
    },
    label: {
        ...commonStyles(FOUNDATIONS, FONT).label,
        color: FOUNDATIONS.color_comp_actions_quickbutton_tertiary_default_label,
    },
});
//# sourceMappingURL=commonStyles.js.map